<mimecast-ui-alert
  [titleText]="data.title"
  [message]="data.message"
  [severity]="data.severity"
  [actionType]="data.actionType"
  [actionBtnText]="data.actionBtnText"
  (action)="onAction()"
  (closed)="onClosed()"
></mimecast-ui-alert>
